import React from "react";
import "../scss/aboutMototoDoctor.css";
import ico1 from "../Wesite Icons/24-7 roadside assistance for emergencies.png";
import ico2 from "../Wesite Icons/On-demand doorstep bike service & repairs.png";
import ico3 from "../Wesite Icons/Pickup & drop for scheduled maintenance.png";
import ico4 from "../Wesite Icons/Safe towing & transport.png";
import ico5 from "../Wesite Icons/Fast Response.png";
import ico6 from "../Wesite Icons/Verified Mechanics.png";
import ico7 from "../Wesite Icons/Transparent Pricing.png";
import ico8 from "../Wesite Icons/Easy Booking.png";
import ico9 from "../Wesite Icons/Genuine parts & quality service.png";

const AboutMotoDoctor = () => {
  return (
    <section className="about-container">
      <div className="about-content">
        <h1>About MotoDoctor – Your Motorcycle Rescue Partner</h1>
        <p className="subtitle">At MotoDoctor, we keep Chennai’s bikers moving.</p>

        <p className="about-intro">Founded with a mission to make two-wheeler care simple and stress-free, we offer:</p>

        <ul className="about-services">
          <li>
            <img
              src={ico1}
              alt="24/7"
              style={{
                width: 34,
                height: 30,
                marginRight: 8,
                verticalAlign: "middle",
              }}
            />
            24/7 roadside assistance for emergencies
          </li>
          <li>
            <img
              src={ico2}
              alt="On-demand doorstep bike service & repairs"
              style={{
                width: 34,
                height: 30,
                marginRight: 8,
                verticalAlign: "middle",
              }}
            />
            On-demand doorstep bike service & repairs
          </li>
          <li>
            <img
              src={ico3}
              alt="Pickup & drop for scheduled maintenance"
              style={{
                width: 34,
                height: 30,
                marginRight: 8,
                verticalAlign: "middle",
              }}
            />
            Pickup & drop for scheduled maintenance
          </li>
          <li>
            <img
              src={ico4}
              alt=" Safe towing & transport"
              style={{
                width: 34,
                height: 30,
                marginRight: 8,
                verticalAlign: "middle",
              }}
            />
            Safe towing & transport
          </li>
        </ul>

        <h2>Why riders trust us:</h2>
        <ul className="about-trust">
          <li>
            <img
              src={ico5}
              alt="Pickup & drop for scheduled maintenance"
              style={{
                width: 34,
                height: 30,
                marginRight: 8,
                verticalAlign: "middle",
              }}
            />
            Fast response (average 30–45 mins)
          </li>
          <li>
            <img
              src={ico6}
              alt="Verified, skilled mechanics"
              style={{
                width: 34,
                height: 30,
                marginRight: 8,
                verticalAlign: "middle",
              }}
            />
            Verified, skilled mechanics
          </li>
          <li>
            <img
              src={ico7}
              alt="Transparent pricing, no hidden fees"
              style={{
                width: 34,
                height: 30,
                marginRight: 8,
                verticalAlign: "middle",
              }}
            />
            Transparent pricing, no hidden fees
          </li>
          <li>
            <img
              src={ico8}
              alt="Transparent pricing, no hidden fees"
              style={{
                width: 34,
                height: 30,
                marginRight: 8,
                verticalAlign: "middle",
              }}
            />
            Easy booking via the MotoDoctor app
          </li>
          <li>
            <img
              src={ico9}
              alt="Genuine parts & quality service"
              style={{
                width: 34,
                height: 30,
                marginRight: 8,
                verticalAlign: "middle",
              }}
            />
            Genuine parts & quality service
          </li>
        </ul>

        <p className="about-closing">
          Whether you’re a daily commuter or weekend explorer, MotoDoctor ensures your ride stays smooth, safe, and
          ready for the road.
        </p>

        <a href="/rider" className="download-button">
          Download MotoDoctor Today
        </a>
      </div>
    </section>
  );
};

export default AboutMotoDoctor;
